<template>
  <Flex
    justify="end"
    :padding="1"
  >
    <Flex
      direction="column"
      justify="between"
      :class="$style.summary"
      :fullWidth="$screen === 's'"
    >
      <Flex
        justify="between"
        :gap="2"
      >
        <BaseHeading size="xs">{{ t('global.total') }}</BaseHeading>
        <BaseText
          bold
          v-test="'refund-sale-total'"
        >
          {{ filters.currency(total) }}
        </BaseText>
      </Flex>
      <div :class="$style.paymentMethod">
        <Flex
          justify="end"
          :class="$style.availableAmount"
        >
          <BaseText
            color="secondary"
            size="s"
          >
            {{ t('register.invoice.available_refund_amount', { amount: filters.currency(availableRefundAmount ?? 0) }) }}
          </BaseText>
        </Flex>
        <PaymentMethod />
      </div>
    </Flex>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import type { Ref } from 'vue';
import { computed, inject, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import type { Order } from '@/types';
import PaymentMethod from './PaymentMethod.vue';
import { itemLineTotal } from './utils';

const { t } = useI18n();

const props = defineProps<{
  order?: Order | null;
}>();

const selectedItems = inject<Ref<string[]>>('selectedItems');
const selectedTotal = inject<Ref<number>>('selectedTotal');
const availableRefundAmount = inject<Ref<number>>('availableRefundAmount');
const selectedOrderItems = computed(
  () =>
    props.order?.items?.filter((item) =>
      selectedItems?.value.includes(item.id),
    ) ?? [],
);

const total = computed(() =>
  selectedOrderItems.value.reduce((sum, item) => sum + itemLineTotal(item), 0),
);

watchEffect(() => {
  if (selectedTotal) selectedTotal.value = total.value;
});
</script>

<style
  lang="scss"
  module
>
.paymentMethod {
  border-top: 1px solid var(--color-border-input);
  padding-top: $spacing;
}

.availableAmount {
  margin-bottom: $spacing;
}

.summary {
  width: 40%;
}
</style>
